import {requestAsk, getToken} from '../baseRequest'

export const getSliderMenu = (config = {}) => {
  let url = 'user/getMenuPermission'
  return requestAsk('http', 'json', url, config)
}

// 点击iframe时判断token是否过期
export const checkSessionTimeout = (config = {}) => {
  let url = 'user/checkSessionTimeout'
  config = getToken(config)
  return requestAsk('http', 'json', url, config)
}

export const getSearchData = (config = {}) => {
  let url = 'user/getSearchMenuName'
  config = getToken(config)
  return requestAsk('http', 'json', url, config)
}

export const getGuessData = (config = {}) => {
  let url = 'domp/getData'
  config = getToken(config)
  return requestAsk('http', 'json', url, config)
}



// WEBPACK FOOTER //
// ./src/utils/api/index.js